import {Box, FormControlLabel, Toolbar, useTheme} from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import { MaterialUISwitch } from "../forms/UserForm"
import { useContext } from "react"
import { ThemeContext } from "../../App"
import UserControls from "./UserControls"
import { useLocation } from "react-router-dom"

const DesktopToolbar = ({fromHelp = null}) => {
     const { control } = useForm()
      const location = useLocation()
     const state = location.state
       const { mode, toggleTheme } = useContext(ThemeContext)
     const theme = useTheme()
    return (
        <Toolbar sx={{backgroundColor: theme.palette.newColors.gray}}>
            
            <Box sx={{ flex: 1, display: 'flex'}}>
                <img src='../assets/ADaMS_Logo_White_12_06.png' alt='ADaMS logo' style={{ width: 140, height: 'auto',marginLeft:!fromHelp && 260}} />
            </Box>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center',justifyContent:'flex-end' }}>
                <Controller
                    name='theme'
                    control={control}
                    render={({ field, field: { onChange } }) => (
                        <FormControlLabel
                            control={
                                <MaterialUISwitch
                                    checked={mode === 'dark'}
                                    onClick={e => {
                                        onChange(e.target.checked)
                                        toggleTheme(e.target.checked ? 'dark' : 'light')
                                    }}
                                    {...field}
                                />}/>
                    )}
                />
                <UserControls state={location.state} noElev={true}/>
            </Box>
        </Toolbar>
    )
}
export default DesktopToolbar